<template>
  <div class="bg bg--about">
    <div class="bg--overlay bg--overlay__ab"></div>
    <section class="sections" :style="[tab === 0 ? {'margin-top': '0px'} : {'margin-top': '50px'}]">
      <v-container>
        <v-row class="mb-10" align="center">
          <v-col cols="12" sm="7">
            <div class="sections-box">
              <div class="sections--border">
                <span class="sections--title">Songket sebagai</span>
                <h2 class="sections--menu">
                  {{items[tab].name}}
                </h2>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="5">
            <v-tabs
              class="blogs--nav"
              v-model="tab"
              background-color="transparent"
              grow
            >
              <v-tab v-for="(item, index) in items" :key="index">
                {{ item.name }}
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <v-row>
          <v-tabs-items v-model="tab" class="blogs--content">
            <v-tab-item v-for="(item, index) in data" :key="index">
              <v-container>
                <article>
                  <v-row>
                    <v-col cols="12" sm="4" class="pr-15">
                      <v-card flat class="sections--img">
                        <div class="sections--img__zindex">
                          <div class="d-flex">
                            <img
                              class="sections--img__resp"
                              alt="gambar"
                              :src="item.image"
                            />
                          </div>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="4" class="details--line pl-5">
                      <v-list class="details--list">
                        <v-list-item v-for="(detail, index) in item.details" :key="index">
                          <v-list-item-content>
                            <v-list-item-title class="white--text">
                              {{ detail }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <div class="details--sosmed mt-10">
                        <!-- <p class="mb-0 pl-3">Share</p> -->
                        <v-btn
                          v-for="(social, i) in socials"
                          :key="i"
                          :color="social.color"
                          class="white--text mr-3"
                          fab
                          icon
                          style="border: 1px white solid; height: 45px; width: 45px;"
                        >
                          <v-icon>{{ social.icon }}</v-icon>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="mt-10">
                      <h2 class="mb-10">
                        {{item.title}}
                      </h2>
                      <p style="white-space: pre-line">
                        {{item.description}}
                      </p>
                    </v-col>
                  </v-row>
                </article>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "Blog",
  data() {
    return {
      tab: 0,
      items: [
        {
          key: 'technique',
          name: 'Teknik'
        },
        {
          key: 'inspiration',
          name: 'Inspirasi'
        },
        {
          key: 'tradition',
          name: 'Tradisi'
        }
      ],
      details: [
        "Inventory No. 123455",
        "Gold, silk",
        "South Sumatra",
        "Aquired in 1879",
        "Technique"
      ],
      socials: [
        {
          icon: "mdi-facebook"
        },
        {
          icon: "mdi-twitter"
        },
        {
          icon: "mdi-instagram"
        }
      ],
      data: [
        {
          title: "MENYUNGKIT BENANG, MENJALIN KEINDAHAN",
          description: "Selembar kain tenun tercipta dari silangan benang lungsi dan benang pakan. Benang lungsi (disebut juga lungsin atau lusi) merupakan benang yang disusun sejajar, memanjang, dan vertikal pada alat tenun. \n \nDalam proses menenun, benang lungsi disusun terlebih dahulu sebelum benang pakan sebagai bidang pengisi akan diselipkan atau digerakkan oleh penenun. \n \nTradisi menenun songket di Indonesia pun mengenal bermacam-macam bahan – mulai dari serat pisang-pisangan dan nanas-nanasan, pintalan kapas, sutra, hingga benang perak dan emas yang mengilat. \n \nLantas, apa itu songket? Songket sendiri merupakan teknik menyungkitkan benang tambahan pada benang lungsi dan atau benang pakan untuk membentuk motif-motif yang diinginkan. \n \nPembentukan motif ini dilakukan bersamaan saat proses menenun kain. Karena motif pada selembar songket tercipta karena adanya benang tambahan yang disungkitkan, maka ciri khas dari kain songket adalah permukaannya akan terasa timbul jika diraba. \n \nPada awalnya, istilah songket digunakan di Sumatera Barat dan Palembang yang lebih dekat kepada pengertian menyungkitkan benang emas atau perak. \n \nIstilah songket juga populer di Jawa dan Bali, tetapi terdapat pula penyebutan lokal lainnya, yaitu songke (suku bangsa Manggarai di Flores dan Bima di Sumbawa), jongkit (Batak Karo di Sumatra Utara), suje (Ternate), subbi’ dan arekare’ (Bugis di Sulawesi Selatan), dan pilih atau pileh (Dayak Iban di Kalimantan Barat).",
          image: require(`@/assets/img/feature_technique.png`),
          details: [
            "TIKULUAK",
            "Sutra, benang emas",
            "P. 194 cm, L. 48 cm",
            "Sumatra Barat",
            "Awal abad ke-20",
            "No. Inv. 18849"
          ]
        },
        {
          title: "KEAJAIBAN MOTIF SONGKET INDONESIA",
          description: "Motif-motif indah songket pada hakikatnya tercipta dari alam melalui daya imajinasi dan kerja tangan para penenunnya. Beragam inspirasi dari alam dan segala hal dalam ruang kehidupan manusia diciptakan ulang dalam rupa benang yang ditenun menjadi kain –bunga-bunga yang bermekaran, sulur dedaunan yang bergerak liar, pucuk bambu yang tumbuh menjulang, kepakan sayap burung yang mengudara, ayam jantan yang kokoh, ataupun kerlip kejora di angkasa. Semuanya merupakan buah kontemplasi para penenun yang menangkap sebuah hal indah dan menuangkannya menjadi pola unik kain songket. \n \nTak berhenti di situ, para penenun songket mengarungi ruang imajinasi yang lebih luas. Perjumpaannya dengan budaya-budaya lain menjadi pemantik untuk menciptakan motif songket yang lebih raya. Kapal yang berlayar menjadi salah satu inspirasi motif songket yang berakar pada unsur-unsur budaya penutur rumpun bahasa Austronesia. \n \nKomoditas dari Tiongkok, India, Timur Tengah, dan Eropa juga menjadi sumber inspirasi para penenun untuk menciptakan bentuk-bentuk baru yang selaras dengan perspektif kelokalan. Lalu keranjang bunga pada kain patola dari Gujarat turut hadir dalam tampilan dan makna baru di selembar koffo dari Kepulauan Sangihe dan Talaud. \n \nKeelokan kupu-kupu pada keramik Tiongkok sangat dikagumi masyarakat Nusantara, dan lantas diapresiasi oleh bangsawan Bali dan kain-kain songket yang mereka kenakan. Unsur budaya Islam juga ditampilkan lewat tenunan beraksara Arab, penonjolan unsur flora, dan gambar diam makhluk hidup. \n \nSecara keseluruhan, motif-motif songket adalah wujud budaya material dari masing-masing kebudayaan yang beragam dan memiliki kekhasan tertentu. \n \nMeski silang budaya bisa menjadi pintu masuknya inspirasi, tak ayal yang menjadi sorotan utama adalah kreativitas dan kemampuan para penenun dalam merespons unsur-unsur kehidupan di sekitarnya. Dari selembar benang, mereka kemudian melukiskannya melalui karya tekstil songket yang penuh daya pikat dan sarat makna.",
          image: require(`@/assets/img/feature_inspiration.png`),
          details: [
            "KOFFO",
            "Serat abaka",
            "P. 186 cm, L. 63 cm",
            "Kepulauan Sangihe Talaud, Sulawesi Utara",
            "Awal abad ke-20",
            "No. Inv. 20480"
          ]
        },
        {
          title: "TRADISI SONGKET INDONESIA: Memori Kolektif dan Kisah Para Leluhur",
          description: "Tradisi menenun dengan teknik songket dan pemakaian kain songket dikenal secara luas di hampir seluruh wilayah Indonesia – dari Aceh hingga pesisir utara Papua, dari gugusan kepulauan Sangihe, Maluku, hingga Nusa Tenggara. Tiap kain songket yang ditenun oleh tangan para perempuan hebat Indonesia tidak hanya sebagai wujud sumbangsih menghidupkan memori kolektif budaya bangsa, tetapi juga bentuk cinta terhadap tradisi, kisah, dan pengetahuan yang diwariskan oleh para leluhur sebelumnya. \n \nPara ahli mengemukakan beragam pendapat terkait berawalnya tradisi songket di Nusantara. Hingga kini, belum ada pendapat secara pasti dan bukti yang kuat untuk menyimpulkan secara tepat mengenai kapan tradisi songket ini bermula. Namun, Robyn Maxwell (2003) merujuk pada kontak budaya antara Nusantara dengan pedagang tekstil dari India dan Tiongkok di wilayah Selat Malaka, pelabuhan-pelabuhan di Sumatra dan utara Jawa sekitar abad ke-7 hingga ke-15 Masehi sebagai awalan hadirnya tradisi tenun songket. \n \nMelihat dari bukti arkeologi, beberapa arca menunjukkan peradaban yang menggunakan busana yang motifnya menyerupai songket di zaman sekarang. Motif tertua yang terekam dan diduga serupa songket tampak pada dinding Candi Mendut di Magelang, Jawa Tengah (8-9 Masehi) dan pada arca Prajnaparamita dari Candi Gumpung kompleks situs Muarajambi (Purwanti dan Siregar, 2016). Motif tersebut berupa bunga berbentuk bulat. \n \nMenenun kain songket diwariskan dalam lingkup keluarga; Seorang gadis kecil yang menemani ibu, bibi, maupun neneknya saat menenun secara langsung dapat belajar dan menyerap pengetahuan ini. Penggunaan songket di Indonesia bukan hanya penutup tubuh semata, melainkan sebagai perangkat sosial dan budaya yang menjadi identitas keberagaman suku bangsa dan bagian dari sejarah budaya bangsa pula. \n \nPada sebagian besar suku bangsa di Indonesia, kain-kain songket memegang peranan penting dalam upacara daur hidup manusia. Pada peristiwa kelahiran, masyarakat Batak menggendong bayi menggunakan ulos sadum dengan untaian rumbai manik (pompom) pemberian seorang ompung (kakek/nenek) kepada cucunya yang baru lahir. Demikian juga pada masyarakat Bira di Sulawesi Selatan yang menggunakan kain gambara’ untuk menutupi tubuh seorang ibu yang baru melahirkan sebagai ungkapan syukur dan harapan. \n \nPenggunaan songket paling meriah dapat dilihat pada saat upacara pernikahan, yang biasanya kain songket juga digunakan sebagai bagian dari hantaran pengantin. Tradisi ini lestari di banyak suku bangsa seperti Aceh, Batak, Palembang, Minangkabau, Melayu di pesisir Sumatra dan Kalimantan, Bugis, Makassar, Bali, Nusa Tenggara, dan beberapa suku lainnya yang mengenal teknik songket dalam pengetahuan wastra lokal mereka. \n \nPada tahapan kehidupan selanjutnya yakni kematian, kain songket turut hadir sebagai pelengkap upacara. Masyarakat Minangkabau menggunakan songket bolah buluah sebagai penutup jenazah. Sementara itu, masyarakat Manggarai menggunakan lipa songke untuk menghadiri upacara kematian. Demikian tradisi dinamis berwastra songket di Indonesia telah menjadi bagian dari memori kolektif budaya bangsa dalam proses memahami masa lalu dan keterhubungan dengan masa kini.",
          image: require(`@/assets/img/feature_tradition.png`),
          details: [
            "IJA DUA BLAH HAH",
            "Sutra, benang perak",
            "P. 541 cm, L. 84 cm",
            "Aceh ",
            "Awal abad ke-19",
            "No. Inv. 21472"
          ]
        }
      ]
    };
  },
  mounted() {
    this.tab = parseInt(this.$route.params.id)
  },
  watch: {
    tab(newState) {
      this.$emit('changeTab', newState)
    }
  }
};
</script>

<style lang="scss" scoped></style>
